"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDatePickerAnnualAndDriveAwayWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("react-datepicker/src/stylesheets/datepicker.scss");
var moment = require("moment");
var CustomDatePickerWidget_1 = require("./CustomDatePickerWidget");
var CustomDatePickerAnnualAndDriveAwayWidget = /** @class */ (function (_super) {
    __extends(CustomDatePickerAnnualAndDriveAwayWidget, _super);
    function CustomDatePickerAnnualAndDriveAwayWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.savedAnnualCoverEndDate = null;
        _this.renderStartDateLabel = function (coverName, startDate) {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: startDate && ((0, jsx_runtime_1.jsxs)("label", { className: _this.getSetting('startDateCssClass', 'cover-start-date'), children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: coverName }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("span", { className: "font-weight-light", children: ["Start:", ' ', moment(startDate, moment.ISO_8601).utc().format("DD MMM YYYY, HH:mm")] })] })) }));
        };
        _this.renderExpiryDateLabel = function (endDate) {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: endDate && ((0, jsx_runtime_1.jsx)("label", { className: _this.getSetting('expiryDateCssClass', 'cover-expiry-date'), children: (0, jsx_runtime_1.jsxs)("span", { className: "font-weight-light", children: ["End:", ' ', moment(endDate, moment.ISO_8601).utc().format("DD MMM YYYY, HH:mm")] }) })) }));
        };
        return _this;
    }
    CustomDatePickerAnnualAndDriveAwayWidget.prototype.render = function () {
        return _super.prototype.render.call(this);
    };
    CustomDatePickerAnnualAndDriveAwayWidget.prototype.renderInputField = function () {
        if (this.props.interaction.headerInfo.endDate) {
            this.savedAnnualCoverEndDate = this.props.interaction.headerInfo.endDate;
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-control-datepicker", children: [_super.prototype.renderInputField.call(this), this.renderStartDateLabel("5-Day Drive Away cover", this.props.interaction.uistate.relatedInteractionStartDate), this.renderExpiryDateLabel(this.props.interaction.uistate.relatedInteractionEndDate), this.renderStartDateLabel("Annual cover", this.props.interaction.headerInfo.startDate), this.renderExpiryDateLabel(this.savedAnnualCoverEndDate)] }));
    };
    return CustomDatePickerAnnualAndDriveAwayWidget;
}(CustomDatePickerWidget_1.CustomDatePickerWidget));
exports.CustomDatePickerAnnualAndDriveAwayWidget = CustomDatePickerAnnualAndDriveAwayWidget;
//# sourceMappingURL=CustomDatePickerAnnualAndDriveAwayWidget.js.map